import { IQueryOptions } from "./IQueryOptions";
import { changed } from "./changed";

export function isQueryOptionsChanged<TQueryOptions extends Record<string, any>, TFilter>(this: IQueryOptions<TFilter>, newQueryOptions: TQueryOptions, oldQueryOptions: TQueryOptions): boolean {
  let isChanged = oldQueryOptions ? changed.call(this, newQueryOptions, oldQueryOptions) : true;
  if (!isChanged) {
    isChanged = changed.call(this, oldQueryOptions!, newQueryOptions, { expectSecondaryKey: false });
  }

  return isChanged;
}
